import { axiosInstance } from "@/api/connection"

class ProductService {
	async getBySlug(slug, params) {
		const instance = axiosInstance()
		const response = await instance.get(`products_slug/${slug}`, { params })
		return response
	}
}

export default new ProductService()
